<template>
    <div>
        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ (isEditItems 
                            ? $t('editar')  
                            : $t('vincular')) + ' ' + 
                        (tipoRegraProduto && tipoRegraProduto.id == 0 
                            ? $t('produto') 
                            : $t('grupo'))}}
                </h1>
            </div>
            <div class="header-buttons">
                <button
                    class="delete-btn"
                    type="button"
                    tag="button"
                    @click="onFecharModal"
                >
                    {{ $t('voltar') }}
                </button>
                <button 
                    class="save-btn" 
                    type="button" 
                    @click="save" 
                    :disabled="isSaving">
                        {{ $t('salvar') }}
                    <svg class="svg-loader" v-if="isSaving">
                        <use :xlink:href="require('@/assets/img/icons/loader.svg')+'#layer'"></use>
                    </svg>
                </button>
            </div>
        </div>
        <div class="form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-4">
                    <v-input
                        v-model="inicio"
                        placeholder="inicio"
                        :maxlength="50"
                        :title="'inicio'"
                        :required="true"
                        :msg="'msg-campo-obrigatorio'"
                        :invalid="!inicio"
                        uppercase/>
                </div>
                <div class="column is-4">
                    <v-input
                        v-model="fim"
                        placeholder="fim"
                        :maxlength="50"
                        :title="'fim'"
                        :required="true"
                        :msg="'msg-campo-obrigatorio'"
                        :invalid="!fim"
                        uppercase/>
                </div>
                <div class="column is-4">
                    <v-input
                        v-model="valor"
                        placeholder="valor"
                        :maxlength="50"
                        :title="'valor'"
                        :required="true"
                        :msg="'msg-campo-obrigatorio'"
                        :invalid="!valor"
                        uppercase/>
                </div>
                <div class="column is-4">
                    <v-input
                        v-model="descontoMaximo"
                        placeholder="desconto-permitido"
                        :maxlength="50"
                        :title="'desconto-permitido'"
                        :required="true"
                        :msg="'msg-campo-obrigatorio'"
                        :invalid="!descontoMaximo"
                        uppercase/>
                </div>
                <div class="column is-4">
                    <vss-select
                        ref="tipoRegraProduto"
                        :title="'tipo-regra-produto'"
                        :disabled="isItemsSelecionados"
                        :options="tipoRegraProdutoSelect"
                        v-model="tipoRegraProduto"
                        :placeholder="'selecione'"
                        @input="$emit('resetPagination', tipoRegraProduto)"
                        mlLabels/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// SERVICES
import RegrasDescontoItemService from "@/services/RegrasDescontoItemService";
import Message from "@/models/Message";

export default {
    components: {
        Message,
    },
    props: {
        isEditItems: {
            type: Boolean,
            default: false,
        },
        regraDesconto: {
            type: Object,
            default: {},
        },
        itensSelecionados: {
            type: Array,
            default: [],
        },
        isItemsSelecionados: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            serviceItemDesconto: new RegrasDescontoItemService(this.$http, this.$router),
            inicio: 0,
            fim: 0,
            valor: 0,
            descontoMaximo: 0,
            isSaving: false,
            tabPreco:{},
            tipoRegraProduto: null,
            tipoRegraProdutoSelect: [
                { id: 0, label: 'por-produto' },
                { id: 1, label: 'por-grupo' }
            ],
            msgs: [],
        };
    },
    created() {
        console.log(this.itensSelecionados)

        this.tipoRegraProduto = this.regraDesconto && this.regraDesconto.tipoRegraProduto 
            ? JSON.parse(JSON.stringify(this.regraDesconto.tipoRegraProduto)) 
            : this.tipoRegraProdutoSelect[0];
    },
    methods: {
        save() {
            this.isSaving = true
            const politicaDesconto = this.mapOnSave();
                this.serviceItemDesconto
                    .insertBulk(politicaDesconto)
                    .then((value) => {
                        if (value.status == 200) {
                            this.$root.showMessage("success", "msg-save-situacao", true);
                            this.onFecharModal();
                        } else {
                            this.$root.showMessage('error', 'msg-erro-salvar');
                        }
                    })
                    .catch((e) => {
                        this.$root.showMessage("alert", e.message, true);
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                        this.isLoadingEdit = false;
                    });
        },
        onFecharModal() {
            this.$emit('fecharModal', true);
        },
        mapOnSave(){
            return {
                idVenPoliticaDesconto: this.regraDesconto.id,
                venPoliticaDescontoItemList: this.itensSelecionados.map((item)=>{
                    return {
                        idVenPoliticaDescontoItem: item.idVenPoliticaDescontoItem,
                        idGrupoProduto: this.isEditItems 
                            ? item.idGrupoProduto 
                                ? item.idGrupoProduto 
                                : 0
                            : this.tipoRegraProduto && this.tipoRegraProduto.id == 1 
                                ? item.id 
                                : 0,
                        idProduto: this.isEditItems 
                            ? item.idProduto 
                                ? item.idProduto 
                                : 0
                            : this.tipoRegraProduto && this.tipoRegraProduto.id == 0 
                                ? item.id 
                                : 0,
                        inicio: this.inicio,
                        fim: this.fim,
                        valor: this.valor,
                        decontoMaximo: this.descontoMaximo,
                        regrasDesconto: 0
                    }
                })
            }
        },
    }
};
</script>

<style lang="scss" scoped>
.aba-produto {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>

